import { PageHeader } from '@/components/page-header';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { DollarSign } from 'lucide-react';

export function ProfitabilityPage() {
  return (
    <div className="space-y-6">
      <PageHeader 
        title="Project Profitability" 
        description="Real-time project margin and profitability analysis"
      />

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <DollarSign className="h-5 w-5 text-green-600" />
            Profitability Analysis
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            This feature is in preview. Enable Live Mode in Feature Labs to use with your real data.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
